export default {
    namespaced: true,
    state: {
        total: 0,
        popup_status: false,
        popup_title: ''
    },
    getters: {
        getTotal: state => state.total,
        getPopupStatus: state => state.popup_status,
        getPopupTitle: state => state.popup_title
    },
    mutations: {
        setTotal(state, value){
            state.total = value
        },
        setPopupStatus(state, value){
            state.popup_status = value
        },
        setPopupTitle(state, value){
            state.popup_title = value
        },
    }
}
